import type { Immutable } from "immer";
import React from "react";

import type { ReviewsBlock as ReviewsBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const HomeOwnerSayingsBlock = (block: {
    value: Immutable<ReviewsBlockValue>;
}): React.JSX.Element => (
    <section
        className={concatClassNames([
            styles.ownerReviews,
            "home-oct16-owner-reviews",
        ])}
    >
        <div className="main-container">
            <h4 className={styles.homeOct16OwnerReviewsTitle}>
                {block.value.title}
            </h4>
            <div
                className={concatClassNames([
                    styles.ownerReviewsReviews,
                    "home-oct16-owner-reviews__reviews",
                ])}
            >
                {(block.value.reviews ?? []).map((review, index) => (
                    <div className={styles.ownerReview} key={index}>
                        <h3
                            className={concatClassNames([
                                styles.homeOct16OwnerReviewCopy,
                                "quote",
                            ])}
                        >
                            &quot;{review.title}&quot;
                        </h3>
                        <p
                            className={concatClassNames([
                                styles.ownerReviewAuthor,
                                "home-oct16-owner-review__author",
                            ])}
                        >
                            {review.author}
                        </p>
                        <p
                            className={concatClassNames([
                                styles.ownerReviewLocation,
                                "home-oct16-owner-review__location",
                            ])}
                        >
                            {review.city}, {review.state}
                        </p>
                    </div>
                ))}
            </div>
            {block.value.read_all_link ? (
                <div
                    className={concatClassNames([
                        styles.ownerReviewsLinkContainer,
                        "home-oct16-owner-reviews__link-container",
                    ])}
                >
                    <a
                        href={block.value.read_all_link.url}
                        className={concatClassNames([
                            styles.ownerReviewsLink,
                            "home-oct16-owner-reviews__link",
                            "link",
                        ])}
                    >
                        Read More Reviews
                    </a>
                </div>
            ) : null}
        </div>
    </section>
);
